import { Select, Show } from "shared/components";
import { type Register } from "shared/hooks";
import { AmenitiesSelect } from "./components/AmenitiesSelect";
import { SectionCard } from "shared/app/SectionCard";
import { DOG_SIZE_UNSPECIFIED, dogSizeOptions } from "./dog-size";

const petOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];

export type PetPolicyField = "cats_allowed" | "dogs_allowed" | "dog_size";

interface AmenitiesFormProps {
  headerExtra?: React.ReactNode;
  register: Register;
  selectedAmenities: number[];
  isUnit?: boolean;
  footer?: React.ReactNode;
  level?: "property" | "unit";
  showDogSize?: boolean;
  onPetPolicyChange?: (field: PetPolicyField) => void;
}

export const AmenitiesForm = (props: AmenitiesFormProps) => {
  const {
    register,
    selectedAmenities,
    level = "property",
    headerExtra,
    footer,
    showDogSize,
    onPetPolicyChange
  } = props;

  const handleSelect = (value: number[]) => {
    register("amenities").onChange(value);
  };

  const wrapPetPolicy = (field: PetPolicyField) => {
    const base = register(field);
    return {
      ...base,
      onChange: (val: unknown) => {
        onPetPolicyChange?.(field);
        base.onChange(val);
      }
    };
  };

  return (
    <SectionCard title="Amenities" headerExtra={headerExtra} footer={footer}>
      <div className="space-y-4">
        <div>
          <div className="grid grid-cols-2 gap-4 items-start">
            <div>
              <Select
                id="cat-allowed"
                label="Cat allowed"
                options={petOptions}
                required
                {...wrapPetPolicy("cats_allowed")}
              />
            </div>
            <div className="space-y-4">
              <div>
                <Select
                  id="dog-allowed"
                  label="Dog allowed"
                  options={petOptions}
                  required
                  {...wrapPetPolicy("dogs_allowed")}
                />
              </div>
              <Show if={showDogSize && register("dogs_allowed").value}>
                <div>
                  <Select
                    id="dog-size"
                    label="Dog size"
                    options={dogSizeOptions}
                    {...wrapPetPolicy("dog_size")}
                    value={register("dog_size").value ?? DOG_SIZE_UNSPECIFIED}
                  />
                </div>
              </Show>
            </div>
          </div>
        </div>

        <AmenitiesSelect
          level={level}
          onSelect={handleSelect}
          selectedAmenities={selectedAmenities}
        />
      </div>
    </SectionCard>
  );
};
